import { VideoBlockData } from 'api/cms';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { AmpVideoBlock } from './AmpVideoBlock';
import { VideoBlock } from './VideoBlock';

export const VideoBlockMapping: BlockMapping<VideoBlockData> = {
  invariant: [
    {
      prop: 'videoUrl',
      msg: 'URL required for video',
    },
    {
      prop: 'width',
      msg: 'width required for video',
    },
  ],
  width: ({ width }) => (width === 'WIDE' ? 'INSET' : 'NARROW'),
  Component: VideoBlock,
  AmpComponent: AmpVideoBlock,
};
